<template>
    <div class="view-container">
        <modal :showDialog="(activeModal == ActiveModal.AddEdit)" @close="closeModal" :title="selectedElement == null ? $t('AddProblem') : $t('EditProblem')">
            <problem-modal :existingProblem="selectedElement" :systemId="systemId" :systemName="systemName" @saved="closeModal"/>
        </modal>
        <modal :showDialog="(activeModal == ActiveModal.Info)" @close="closeModal" :title="$t('ProblemInfo')">
            <problem-info-modal :existingProblem="selectedElement"/>
        </modal>
        <modal :showDialog="(activeModal == ActiveModal.ConfirmBox)" @close="closeModalOnly" >
          <info-confirm :text="confirmBoxText" @confirm="closeModalOnly"/>
        </modal>
        <div style="width: 100%; height: 100%; overflow-x: auto">
		    <div class="max-grid">
                <ejs-grid ref="grid" height='100%' width='100%' :toolbar='toolbar' :toolbarClick='toolbarClick' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="problems" :allowPaging="true" :pageSettings='pageSettings' :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true">
                    <e-columns>
                        <e-column field='status' :headerText="$t('Status')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
                        <e-column field='systemName' :headerText="$t('System')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
                        <e-column v-if="(visitId != null && visitMode == 'ACTIVE')" field='hasSolutionsDuringVisit' :headerText="$t('DoneDuringVisit')" :template="IconTemplate"></e-column>
                        <e-column field='deviceName' :headerText="$t('Device')" textAlign='Left' :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
                        <e-column field='title' :headerText="$t('Title')" textAlign='Left' :customAttributes="customAttributes" :filter="filterOptions"></e-column>
                        <e-column field='reportedDate' :headerText="$t('ReportedDate')" textAlign='Left' type="datetime" :format="dateTimeFormatOptions" :customAttributes="customAttributes"></e-column>
                        <e-column field='resolvedDate' :headerText="$t('ResolvedDate')" textAlign='Left' type="datetime" :format="dateTimeFormatOptions" :customAttributes="customAttributes"></e-column>
                        <e-column field='creatorName' :headerText="$t('Creator')" textAlign='Left' :customAttributes="customAttributes" :filter="filterOptions"></e-column>
                        <e-column :headerText="''" :template="ButtonsTemplate" :allowFiltering="false" :allowSorting="false" :customAttributes="customAttributes" width="150px"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
  </template>

  <script>
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import ProblemModal from '../../components/Visits/Problems/ProblemModal.vue';
import ProblemInfoModal from '../../components/Visits/Problems/ProblemInfoModal.vue';
import Modal from '../../components/Modal.vue';
import { VisitsActiveModal } from '@/Models/VisitsActiveModal'
import { ProblemModel } from '@/Models/ProblemModel'
import { getProblems, getProblemsForSystem } from '@/api/api'
import VisitTableButtonsVue from '../../components/Visits/VisitTableButtons.vue';
import moment from 'moment';
import { getActiveProblemsForVisit } from '../../api/api';
import Vue from 'vue'
import InfoConfirm from '@/components/InfoConfirm.vue';;

var context = null

export default {
    components: {
        ProblemModal,
        ProblemInfoModal,
        Modal,
        InfoConfirm
    },
    props: {
        visitId: {
            default: null,
            type: String,
            required: false
        },
        systemId: {
            default: null,
            type: String,
            required: false
        },
        systemName: {
            default: null,
            type: String,
            required: false
        },
        visitMode: {
            default: null,
            type: String,
            required: false
        }
    },
    provide: {
        grid: [Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport]
    },
    data() {
        return {
            problems: [],
            selectedElement: null,
            ActiveModal: {},
            activeModal: null,
            last_mode: ProblemModel.All,
            status: [ 'Incomplete', 'Under Observation', 'Pending For Spares', 'Complete' ],

            // TABLE OPTIONS
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [
                { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right', },
                { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' },
                { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' },
                { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' },
                { text: this.$t('AddProblem'), tooltipText: 'Add Problem', prefixIcon: 'e-add', id: 'addProblem', align: 'Right' },
                { text: this.$t('EditProblem'), tooltipText: 'Edit Problem', prefixIcon: 'e-edit', id: 'editProblem', align: 'Right'},
                'Search',
            ],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "Menu",
                columns: this.systemName != null ? [{ field: 'systemName', matchCase: false, operator: 'equal', value: this.systemName }] : null
            },
            filterCheckBox: {
                type: "CheckBox",
            },
            customAttributes: { class: 'customcss' },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd', type: 'dateTime' },
            confirmBoxText: "",
            ButtonsTemplate: function() {
				return {
					template: {
						extends: VisitTableButtonsVue,
						propsData: {
							show(data, mode){
								switch(mode){
									case 'SOLUTIONS':
                      if(context.systemId != null) {
                          this.$router.push({
                              name: 'settingsProblemSolutionsHistory',
                              params: {
                                  problemId: data.id,
                                  systemId: context.systemId,
                                  systemName: context.systemName
                              },
                          });
                      } else {
                          this.$router.push({
                              name: 'solutionsForProblem',
                              params: {
                                  problemId: data.id,
                              },
                          });
                      }

										break;
                  case 'INFO':
                      context.selectedElement = data
                      context.activeModal = context.ActiveModal.Info
                    break;
								}
							},
              place: context.visitMode != null ? context.visitMode : 'PROBLEMS'
						}
					},
				};
			},
            IconTemplate: function () {
                return {
                    template: Vue.component('IconTemplate', {
                            template: `<svg v-if="data.hasSolutionsDuringVisit" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2.4C6.69807 2.4 2.4 6.69807 2.4 12C2.4 17.3019 6.69807 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4 12 2.4ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM17.5972 8.10311C18.0926 8.54341 18.1372 9.3019 17.6969 9.79724L11.2969 16.9972C11.0692 17.2534 10.7428 17.4 10.4 17.4C10.0572 17.4 9.73083 17.2534 9.50311 16.9972L6.30311 13.3972C5.86281 12.9019 5.90742 12.1434 6.40276 11.7031C6.8981 11.2628 7.65659 11.3074 8.09689 11.8028L10.4 14.3938L15.9031 8.20276C16.3434 7.70742 17.1019 7.66281 17.5972 8.10311Z" fill="#1ECD74"/>
                                </svg>
                                `,
                            data: function() {
                                return {
                                    data: {}
                                }
                            },
                        }
                    )
                }
            },
        }
    },
    methods: {
        prepareProblems(resultProblems){
            this.problems = resultProblems;

            for(let i = 0; i < this.problems.length; i++) {
                this.problems[i].status = this.$t(this.status[this.problems[i].status])
                this.problems[i].resolvedDate = moment(this.problems[i].resolvedDate).format('YYYY-MM-DD')

                if(this.problems[i].resolvedDate == '0001-01-01') {
                    this.problems[i].resolvedDate = null
                }
            }
        },
        async getData(mode) {
            if(mode != undefined) {
                this.last_mode = mode
            }

            if(this.systemId != null && this.visitId != null) {
                var resultProblems = await getActiveProblemsForVisit(this.visitId, this.last_mode)
                this.prepareProblems(resultProblems)
                return;
            } else if(this.systemId != null) {
                var resultProblems = await getProblemsForSystem(this.systemId, this.last_mode)
                this.prepareProblems(resultProblems)
                return;
            } else if (this.visitId != null) {
                var resultProblems = await getActiveProblemsForVisit(this.visitId);
                // console.log(resultProblems)
                this.prepareProblems(resultProblems)
                return;
            }

            var resultProblems = await getProblems(this.last_mode)
            this.problems = resultProblems;

            for(let i = 0; i < this.problems.length; i++) {
                // console.log(this.status[this.problems[i].status])
                this.problems[i].status = this.$t(this.status[this.problems[i].status])

                this.problems[i].resolvedDate = moment(this.problems[i].resolvedDate).format('YYYY-MM-DD')

                if(this.problems[i].resolvedDate == '0001-01-01') {
                    this.problems[i].resolvedDate = null
                }
            }
        },
        closeModalOnly() {
          this.activeModal = this.ActiveModal.None;
        },
        closeModal() {
            this.activeModal = this.ActiveModal.None;
            this.selectedElement = null
            this.getData();
        },
        toolbarClick(args) {
            switch (args.item.id) {
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
                case "addProblem":
                    this.activeModal = this.ActiveModal.AddEdit;
                    break;
                case "editProblem":
                    var selectedRecords = this.$refs.grid.getSelectedRecords()
                    if(selectedRecords.length > 1) {
                        this.confirmBoxText = 'More than one record is selected.';
                        this.activeModal = this.ActiveModal.ConfirmBox;
                        break;
                    } else if (selectedRecords.length == 0) {
                        this.confirmBoxText = 'Nothing is selected.';
                        this.activeModal = this.ActiveModal.ConfirmBox;
                        break;
                    }
                    this.selectedElement = selectedRecords[0]
                    this.activeModal = this.ActiveModal.AddEdit
                    break;
            }
        },
        dataBound() {
            this.$refs.grid.autoFitColumns();
        },
    },
    async mounted() {
        this.ActiveModal = VisitsActiveModal
        this.activeModal = this.ActiveModal.None
        this.getData()

        context = this;
    }
}
</script>

<style scoped>
  .system-info-container {
      /* width: 18vw; */
      background-color: rgba(243, 243, 243, 1);
      padding: 20px;
      border: 1px solid rgba(224, 224, 224, 1);
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
  }

  .system-details-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
  }

  .info-field-text {
      font-weight: bolder;
      word-break: break-word;
  }

  .two-columns-template {
      display: grid;
      grid-template-columns: 80% 20%;
  }
</style>



// WEBPACK FOOTER //
// src/views/Visits/Problems.vue